module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/016-44f9ba10830c5fc5666e95e3a1658869.jpg";